var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 79,
    height: 79,
    rx: 36,
    fill: "#F1F6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_546_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 10C23.7337 10 10.5 23.2337 10.5 39.5C10.5 55.7663 23.7337 69 40 69C56.2663 69 69.5 55.7663 69.5 39.5C69.5 23.2337 56.2663 10 40 10ZM34.103 52.5183L23.1496 41.5886L27.315 37.4114L34.097 44.1817L49.7144 28.5644L53.8857 32.7356L34.103 52.5183Z",
    fill: "#0032FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_546_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(10.5 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5fe598f69d6023813c49c220f6de3cd0.svg";
export { ForwardRef as ReactComponent };